import './legal-page.css';

const sections = [
  {
    title: '1. Thông tin chúng tôi thu thập',
    body: 'Chúng tôi có thể thu thập thông tin hồ sơ cơ bản, dữ liệu đăng nhập, dữ liệu hoạt động thể thao, và các trường dữ liệu cần thiết để vận hành campaign khi bạn sử dụng ứng dụng hoặc kết nối Strava.',
  },
  {
    title: '2. Mục đích sử dụng dữ liệu',
    body: 'Dữ liệu được dùng để xác thực người dùng, hiển thị hoạt động, tính toán tiến độ campaign, lập bảng xếp hạng, hỗ trợ vận hành cộng đồng chạy bộ và cải thiện trải nghiệm sản phẩm.',
  },
  {
    title: '3. Dữ liệu Strava',
    body: 'Khi bạn kết nối Strava, ứng dụng chỉ sử dụng dữ liệu được cấp quyền để cung cấp tính năng liên quan đến campaign và hồ sơ vận động viên. Chúng tôi không bán dữ liệu Strava của bạn cho bên thứ ba.',
  },
  {
    title: '4. Lưu trữ và bảo vệ',
    body: 'Chúng tôi áp dụng các biện pháp hợp lý về kỹ thuật và vận hành để bảo vệ dữ liệu cá nhân khỏi truy cập trái phép, thay đổi hoặc tiết lộ không phù hợp.',
  },
  {
    title: '5. Chia sẻ dữ liệu',
    body: 'Dữ liệu chỉ được chia sẻ khi cần để vận hành dịch vụ, tuân thủ yêu cầu pháp lý hoặc theo sự cho phép của bạn. Một số thông tin thành tích có thể được hiển thị công khai trong leaderboard hoặc trang campaign.',
  },
  {
    title: '6. Quyền của người dùng',
    body: 'Bạn có thể yêu cầu cập nhật, chỉnh sửa hoặc xóa dữ liệu của mình trong phạm vi được phép. Bạn cũng có thể ngắt kết nối Strava và dừng chia sẻ dữ liệu mới từ tài khoản Strava.',
  },
];

export default function PrivacyPolicyPage() {
  return (
    <article className="legal-page">
      <span className="legal-page__eyebrow">Legal</span>
      <h1>Privacy Policy</h1>
      <p className="legal-page__intro">
        Chính sách này giải thích cách CIOC Running Club thu thập, sử dụng và bảo vệ dữ liệu người dùng.
      </p>
      <p className="legal-page__effective">Effective date: July 27, 2026</p>

      <div className="legal-page__sections">
        {sections.map((section) => (
          <section className="legal-page__section" key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </section>
        ))}
      </div>

      <p className="legal-page__contact">
        Với các yêu cầu về quyền riêng tư hoặc dữ liệu Strava, vui lòng liên hệ{' '}
        <a href="mailto:info@digitalleaders.coach">info@digitalleaders.coach</a>.
      </p>
    </article>
  );
}
